class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    if (typeof initUpsellSlider === "function") { 
      initUpsellSlider()
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("submit", function (event) {
    var form = event.target;
    var button = event.submitter || form.querySelector(".product-variant-submit-button");
    if (!button || !button.matches(".product-variant-submit-button") || event.defaultPrevented) return;
    var cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;
    event.preventDefault();
    if (button.disabled || button.dataset.magicCartRequestPending === "true") return;
    button.dataset.magicCartRequestPending = "true";
    var errorMessage = form.querySelector("[data-magic-cart-error]");
    if (errorMessage) errorMessage.hidden = true;
    var formData = new FormData(form);
    formData.append("sections", cartDrawer.getSectionsToRender().map(section => section.id));
    formData.append("sections_url", window.location.pathname);
    cartDrawer.setActiveElement(button);

    (window.MagicGift ? window.MagicGift.request : window.fetch.bind(window))((window.routes && window.routes.cart_add_url || "/cart/add") + ".js", {
      method: "POST",
      body: formData,
    })
      .then(async (response) => {
        var data = await response.json();
        if (!response.ok) {
          var cartError = new Error("Cart request failed");
          cartError.cartMessage = typeof data.description === "string" ? data.description : "";
          throw cartError;
        }
        return data;
      })
      .then((data) => {
        cartDrawer.classList.remove("is-empty");
        cartDrawer.renderContents(data);
      })
      .catch((error) => {
        if (!errorMessage) {
          errorMessage = document.createElement("p");
          errorMessage.setAttribute("data-magic-cart-error", "");
          errorMessage.setAttribute("role", "alert");
          form.appendChild(errorMessage);
        }
        errorMessage.textContent = error.cartMessage || window.cartStrings && window.cartStrings.error || "Impossible d’ajouter cet article au panier.";
        errorMessage.hidden = false;
      })
      .finally(() => {
        button.dataset.magicCartRequestPending = "false";
      });
  });

});


// -------------- Cart Discount coupon




const cartDrawer = document.querySelector('cart-drawer');
const cartIcon = document.getElementById('cart-icon-bubble'); 

// Store discount input and message state globally
let discountInputValue = '';
let discountErrorMessage = '';
let discountMessageColor = 'red';
const initializedDiscountInputs = new WeakSet();
const initializedDiscountButtons = new WeakSet();

// Create a MutationObserver to detect changes within the cart drawer content
const cartContentObserver = new MutationObserver((mutationsList) => {
  if (mutationsList.some(mutation => mutation.type === 'childList')) initializeDiscountFunctionality();
});

// Start observing the cart drawer content for any changes
if (cartDrawer) cartContentObserver.observe(cartDrawer, { childList: true, subtree: true });

// Listen for the cart icon click to ensure discount functionality works
cartIcon?.addEventListener('click', () => {
  initializeDiscountFunctionality();
});
initializeDiscountFunctionality();

// Function to initialize the discount functionality
function initializeDiscountFunctionality() {

  const discountInput = document.getElementById('discount-code');
  const discountMessage = document.getElementById('discount-message');
  const discountButton = document.getElementById('apply-discount-btn');

  // Restore the previous input value and error message
  if (discountInput && !initializedDiscountInputs.has(discountInput)) {
    discountInput.value = discountInputValue;
    discountInput.addEventListener('input', () => { discountInputValue = discountInput.value; });
    initializedDiscountInputs.add(discountInput);
  }
  if (discountMessage) {
    discountMessage.style.display = discountErrorMessage ? 'block' : 'none';
    discountMessage.style.color = discountMessageColor;
    if (discountMessage.textContent !== discountErrorMessage) discountMessage.textContent = discountErrorMessage;
  }

  // Ensure the discount button exists and bind the click event
  if (discountButton && !initializedDiscountButtons.has(discountButton)) {
    discountButton.addEventListener('click', handleDiscountCode);
    initializedDiscountButtons.add(discountButton);
  }
}

// Function to handle discount code logic
function handleDiscountCode(event) {
  event?.preventDefault();

  const discountInput = document.getElementById('discount-code');
  const discountMessage = document.getElementById('discount-message');
  const discountButton = document.getElementById('apply-discount-btn');
  if (!discountInput || !discountMessage || !discountButton || discountButton.disabled) return;
  const discountCode = discountInput?.value.trim();

  // Save the current input value globally
  discountInputValue = discountCode;

  // Validate the input to ensure the discount code is not empty
  if (!discountCode) {
    discountErrorMessage = "Veuillez entrer un code promo.";
    discountMessageColor = 'red';
    initializeDiscountFunctionality();
    return;
  }

  // Add loading state to the button
  discountButton.classList.add('button-loading');
  discountButton.disabled = true;

  // Keep discount changes in the same queue as quantities and the automatic gift.
  (window.MagicGift ? window.MagicGift.request : window.fetch.bind(window))(routes.cart_update_url, {
    ...fetchConfig(),
    body: JSON.stringify({
      discount: discountCode,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
    .then(async (response) => {
      if (!response.ok) throw new Error('Discount request failed');
      const cart = await response.json();
      const applications = [
        ...(cart.cart_level_discount_applications || []),
        ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
      ];
      const applied = applications.some(application => application && application.type === 'discount_code' && String(application.title).toLowerCase() === discountCode.toLowerCase());

      if (applied) {
        discountErrorMessage = "Code promo appliqué avec succès!";
        discountMessageColor = 'green';
        
      } else {
        discountMessageColor = 'red';
        discountErrorMessage = "Code promo invalide.";
      }

      // Update the message
      initializeDiscountFunctionality();

      document.querySelector('cart-drawer').renderContents(cart);
    })
    .catch((error) => {
      console.error("Erreur lors de l'application du code promo:", error);
      discountErrorMessage = "Une erreur s'est produite. Veuillez réessayer.";
      discountMessageColor = 'red';
      initializeDiscountFunctionality();
    })
    .finally(() => {
      // Remove loading state from the button
      discountButton.classList.remove('button-loading');
      discountButton.disabled = false;
    });
}

// Function to update the cart drawer content dynamically
function updateCartDrawerContent() {
  fetch("/cart?view=drawer") // Fetch the updated cart drawer view
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartDrawer = doc.querySelector("#CartDrawer").innerHTML;
      document.querySelector("#CartDrawer").innerHTML = newCartDrawer;


      // Re-bind necessary events after the cart drawer is updated
      bindCartEvents();

      // Reinitialize the discount functionality after updating the cart drawer
      initializeDiscountFunctionality();
    })
    .catch((error) => {
      console.error("Error fetching updated cart drawer content:", error);
    });
}

// Function to bind necessary cart events after the drawer is updated
function bindCartEvents() {

  document.querySelectorAll('.remove-item').forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });

  // Detect cart updates by product addition or quantity change
  document.querySelectorAll('.quantity-update').forEach((input) => {
    input.addEventListener('change', function () {
      updateCartDrawerContent(); // Refresh the cart drawer on quantity change
    });
  });
}
// -------------- End of Cart Discount coupon
